import { useCallback, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { changeDsrPageDisplay, changeSelectSubpage } from "../../digital-sales-room/actions/dsr-actions";

function useChangeSubpageDisplay() {
  
  const dispatch = useDispatch();
  const [clickCount, setClickCount]=useState(0)

  // Access Redux state 
  const currentDisplayPageId = useSelector(state => state.changeDsrPage.selectedDisplayPageId);
  const currentDisplaySubpage = useSelector(state => state.changeDsrPage.selectedDisplaySubpage);
 
  const handleSelectSubpage = useCallback((newSelectedDisplayPageId, newSelectedDisplayFixedSubpageType) => {
    if (newSelectedDisplayPageId && newSelectedDisplayFixedSubpageType) {
      // Error state if both values are provided to avoid showing
      dispatch(changeSelectSubpage(""))
      dispatch(changeDsrPageDisplay(""))
    } else {
      if (newSelectedDisplayPageId && !newSelectedDisplayFixedSubpageType && (newSelectedDisplayPageId !== currentDisplayPageId)) {
        dispatch(changeDsrPageDisplay(newSelectedDisplayPageId))
        setClickCount(prevCount=>prevCount+1)
      } else if (!newSelectedDisplayPageId && newSelectedDisplayFixedSubpageType && (newSelectedDisplayFixedSubpageType !== currentDisplaySubpage)) {
        dispatch(changeSelectSubpage(newSelectedDisplayFixedSubpageType))
        setClickCount(prevCount=>prevCount+1)
      }
    }
  },[dispatch, currentDisplayPageId, currentDisplaySubpage])

  return { handleSelectSubpage, clickCount };
}


export default useChangeSubpageDisplay